module.exports = __webpack_public_path__ + "static/media/fieldedge_flatrate_by_coolfront_logo.8b9f8d1c.png";